export type TabUses =
  | 'default'
  | 'enclosed'
  | 'enclosed-shaded'
  | 'flush'
  | 'header'
  | 'toolbar';

export const isContained = (use?: TabUses) =>
  use === 'enclosed' ||
  use === 'enclosed-shaded' ||
  use === 'flush' ||
  use === 'toolbar';

export const getSelectedTabBackgroundColor = (use?: TabUses) => {
  return use === 'enclosed-shaded'
    ? 'fill-transitional-tabs-default'
    : 'fill-field-default-alt';
};
